import * as React from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  List,
  ListItem,
  ListIcon,
  useColorModeValue as mode,
  Img,
} from '@chakra-ui/react'
import { FaArrowRight } from 'react-icons/fa'

export const LearnDataScience = ({
  title,
  who,
  requirements,
  buttonLabel,
  buttonURI,
}) => {
  return (
    <Box as="section" bg={{ base: 'blue.50' }} overflow="hidden">
      <Box maxW={{ base: 'xl', md: '7xl' }} mx="auto">
        <Stack
          direction={{ base: 'column-reverse', lg: 'row' }}
          spacing={{ base: '20', lg: '8', md: '8', xs: '8' }}
          justify="space-between"
          pb="2em"
          alignItems="center"
        >
          <Box marginTop={{ base: '12', md: '0' }} marginEnd={{ sm: 0, lg: '-12px' }} alignSelf="center" alignContent="center">
            <Img
              pos="relative"
              width={{ base: '100%', md: '700px', lg: 708 }}
              htmlWidth="863"
              htmlHeight="982"
              objectFit="cover"
              src="./img/rocket-3d.png"
              alt="Data Science Course Syllabus"
              pr="3"
            />
          </Box>
          <Box pt="3em" pb="0" px="8">
            <Heading
              display="block"
              size="2xl"
              textAlign="left"
              fontFamily="Tomato Grotesk"
              color={mode('gray.900', 'gray.900')}
              whiteSpace="pre-line"
            >
              {title}
            </Heading>
            <Text
              my="10"
              as="div"
              maxWidth="880px"
              textAlign="left"
              color={mode('gray.800', 'gray.400')}
              fontSize="lg"
            >
              <List spacing={3} mt="6">
                <ListItem>
                  <Heading as="h3"
                    fontFamily="Tomato Grotesk"
                    color="gray.800"
                    fontSize="1.25em"
                    padding="0.5em 0"
                  >
                    👋  Who is this for
                  </Heading>
                  {who}
                </ListItem>
                <ListItem>
                  <Heading as="h3"
                    fontFamily="Tomato Grotesk"
                    color="gray.800"
                    fontSize="1.25em"
                    padding="0.5em 0"
                  >
                    📚 Requirements
                  </Heading>
                  {requirements}
                </ListItem>
              </List>
              {buttonLabel &&
                <Button
                  className="group"
                  mt="2.5em"
                  colorScheme="blue"
                  size="md"
                  pl="1.2em"
                  pr="1em"
                  fontWeight="bold"
                  h="12"
                  as="a"
                  href={buttonURI}
                  target="_blank"
                  rightIcon={<FaArrowRight />}
                >
                  {buttonLabel}
                </Button>
              }
            </Text>
          </Box>
        </Stack>

      </Box>
    </Box>
  )
}